import { render, staticRenderFns } from "./CaptchaImage.vue?vue&type=template&id=7bd5c606"
import script from "./CaptchaImage.vue?vue&type=script&lang=js"
export * from "./CaptchaImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports